<ng-container *ngIf="logoData.length">
    <div class="company-title"><h4>{{'SHARED.ELEMENT.LOGO_CROUSEL.OVER' | translate}} <strong>{{'SHARED.ELEMENT.LOGO_CROUSEL.NUMBER' | translate}}</strong> {{'SHARED.ELEMENT.LOGO_CROUSEL.BRING_NEW_TALENT' | translate}}</h4></div>
    <div [ngClass]="logoData.length < 5 ?( 'company_carousel cstm_company_carousel'+logoData.length): 'company_carousel'">
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let logo of logoData">
                <ng-template carouselSlide>
                    <div class="item"><div class="companyslide"><a routerLink="/employers/{{logo.slug}}"><figure title="{{logo.company_name}}"><img src="{{imagePath + logo.profile_image}}?dim=129x50&type=resize" alt="img" width="129px" height="50px"></figure></a></div></div>
                </ng-template> 
            </ng-container>
        </owl-carousel-o>
    </div>
</ng-container>

